import type React from 'react';

/*
  Phase A.1 — TypeScript token helpers for the assistant-first redesign.

  These mirror the CSS custom properties declared in `tokens.css` (scoped under
  `.tmx`). Components in the new design system reference THESE tokens only —
  never hardcoded hex colors — so the whole new UI follows the Telegram theme.

  Keeping values as `var(--x-*)` strings means inline styles stay theme-aware
  (light/dark) without any JS re-render.
*/

export const color = {
  bg: 'var(--x-bg)',
  surface: 'var(--x-surface)',
  surfaceRaised: 'var(--x-surface-raised)',
  surfaceHover: 'var(--x-surface-hover)',
  border: 'var(--x-border)',
  borderStrong: 'var(--x-border-strong)',
  text: 'var(--x-text)',
  textMuted: 'var(--x-text-muted)',
  accent: 'var(--x-accent)',
  accentText: 'var(--x-accent-text)',
  accentSoft: 'var(--x-accent-soft)',
  link: 'var(--x-link)',
  danger: 'var(--x-danger)',
  dangerSoft: 'var(--x-danger-soft)',
  success: 'var(--x-success)',
  successSoft: 'var(--x-success-soft)',
  warning: 'var(--x-warning)',
  warningSoft: 'var(--x-warning-soft)',
  overlay: 'var(--x-overlay)',
} as const;

/** Spacing scale in px: 4 / 8 / 12 / 16 / 24 / 32. */
export const space = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

export const radius = {
  sm: 10,
  md: 14,
  lg: 20,
  pill: 999,
} as const;

export const shadow = {
  sm: 'var(--x-shadow-sm)',
  md: 'var(--x-shadow-md)',
} as const;

/** Minimum interactive size for thumb-first touch targets. */
export const TOUCH = 44;

export const font: Record<'title' | 'subtitle' | 'body' | 'caption', React.CSSProperties> = {
  title: { fontSize: 22, fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.02em' },
  subtitle: { fontSize: 16, fontWeight: 600, lineHeight: 1.3 },
  body: { fontSize: 15, fontWeight: 400, lineHeight: 1.5 },
  caption: { fontSize: 13, fontWeight: 500, lineHeight: 1.4 },
};
